import { TableContainer } from '@mui/material';
import { styled } from '@mui/system';

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.08)',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.12)',
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  maxHeight: '70vh',
  overflowX: 'auto',
  overflowY: 'auto',
  position: 'relative',
  '& .MuiTable-stickyHeader thead th': {
    background: 'rgba(30,30,30,0.9)',
    backdropFilter: 'blur(8px)',
  },
  [theme.breakpoints.down('sm')]: {
    maxHeight: 'none',
    width: '100%',
    display: 'block',
    overflowX: 'auto',
    overflowY: 'visible',
    WebkitOverflowScrolling: 'touch',
  },
}));

export default StyledTableContainer; 